import React, { Fragment, useContext, useRef } from 'react'
import useMessageObserve from './hooks/useMessageObserve'
import SocketContext from 'context/socket/SocketContext'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import { useHistory } from 'react-router-dom'
import { updateMessage } from './chatSlice'
import { useReduxDispatch } from 'store'
import { toTime } from 'utils/date'

interface MessageProps extends chat.ChatMessage {
  date: Date
  chatId: string
}

const Message: React.FC<MessageProps> = ({ id, chatId, receiverRoom, date, message, readDate, sentDate, deliveredDate, documents }) => {
  const { lang } = useTranslation('chat')

  const messageRef = useRef<HTMLDivElement>(null)

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { sendMessage } = useContext(SocketContext)

  const readMessage = () => {
    if (!chatId || !id) return
    sendMessage({ command: 'readMessage', payload: { chatId, messageId: id } })
    dispatch(updateMessage({ chatId, messageId: id, values: { readDate: new Date().toJSON() } }))
  }

  useMessageObserve(
    readMessage,
    (!receiverRoom && !readDate) ? messageRef : undefined
  )

  return (
    <div
      ref={messageRef}
      className={`chat__message --${receiverRoom ? 'client' : 'service'}`}>
      {documents && <div className='message__files'>
        {documents.map(({ document_title, download_link, thumbnail, is_image }, idx) => download_link
          ? <Fragment key={idx}>
            {thumbnail
              ? <img
                src={thumbnail}
                alt={document_title}
                onClick={() => {
                  if (is_image) {
                    push(window.location.pathname, LOCATION_STATES.popup({ type: 'gallery', content: documents, index: idx }))
                  } else {
                    window.open(thumbnail, '_blank')
                  }
                }} />
              : document_title}
          </Fragment>
          : null)}
      </div>}
      {message && <div className='message__desc'>{message}</div>}
      <div className='message__time'>
        {receiverRoom && (sentDate || readDate || deliveredDate) && <i
          className={`icon cSecText s14 icon--${readDate ? 'check-all' : deliveredDate ? 'check' : 'check o5'}`}
        />}
        {toTime(date, lang)}
      </div>
    </div>
  )
}

export default Message